import { useMutation, useQuery } from "@tanstack/react-query"
import instance from "../instance"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from "react-toastify";

export const useFetchProgress=(filters)=>{
    const fetchProgress=async()=>{
        const {data}= await instance.get(`/api/admin/summary/progress?projectId=${filters?.projectId}`)
        return data
    }
    const query=useQuery({
        queryKey:['progress', filters],
        queryFn:fetchProgress,
        enabled:!!filters.projectId
    })
return query
}
export const useFetchCompletionTrend=(filters)=>{
    const fetchProgress=async()=>{
        const {data}= await instance.get(`/api/admin/summary/completion-trend?projectId=${filters?.projectId}`)
        return data
    }
    const query=useQuery({
        queryKey:['completion trend', filters],
        queryFn:fetchProgress,
        enabled:!!filters.projectId
    })
return query
}
export const useFetchManageReport=(filters)=>{
    const fetchProgress=async()=>{
        const {data}= await instance.get(`/api/admin/manage-report?projectId=${filters?.projectId}&download=${filters?.download||"false"}&pageNumber=${filters.pageNumber}`)
        // const {data}= await instance.get(`/api/admin/flagged-report/${filters?.projectId}`)
        return data
    }
    const query=useQuery({
        queryKey:['manage report', filters],
        queryFn:fetchProgress
    })
return query
}
export const useDownloadManageReport=()=>{
   toast.dismiss()
   const downloadReport= async(filters)=>{
        toast.loading(`Downloading Report`)
        try{

const {data}= await instance.get(`/api/admin/manage-report?projectId=${filters?.projectId}&download=true&pageNumber=${filters.pageNumber}`, {
    responseType: 'blob', // important: treat it as a file
  })
console.log({data})
toast.dismiss()     
toast.success(`Downloaded`)

const blob = data;

// Convert CSV blob to Excel
const reader = new FileReader();
reader.onload = function (e) {
  const text = e.target.result;
  const workbook = XLSX.read(text, { type: 'string' });
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(excelBlob, `Manage_Report_${Date.now()}.xlsx`);
};
reader.readAsText(blob);
// const worksheet = XLSX.utils.json_to_sheet(data);
// const workbook = XLSX.utils.book_new();
// XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

// const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
// const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

// saveAs(blob, `Manage_Report_${Date.now()}.xlsx`);

}
        catch(ex){
console.log({ex})
        }
    }
    const mutation= useMutation({
        mutationFn:downloadReport
    })
return mutation
}
export const useApproveAssessment=()=>{
    const mutation=useMutation(async (assessmentId)=>{
        const {data}=await instance.get(`/api/admin/approve-assessment/${assessmentId}`,)
        return data
    })
    return mutation
}
export const useFetchCriticalIssues=()=>{
    const fetchCriticalIssues=async ()=>{
const {data}= await instance.get(`/api/admin/all-critical-issue`)
return data
    }
const query= useQuery({
    queryFn:fetchCriticalIssues,
    queryKey:["fetch critical issues"]
})
return query

}
export const useUpdateCriticalIssue=()=>{
    const updateCriticalIssue=async (payload)=>{
const {data}= await instance.put(`/api/admin/update-critical-issue/${payload?.id}`, {
    "status": "approved",
  "isRead": false
})
return data
    }
const query= useMutation({
    mutationFn:updateCriticalIssue,
    mutationKey:["update critical issues"]
})
return query

}

